@use "variables" as *;

.noOptionInfo {
  overflow: hidden;
  white-space: nowrap;
  padding: $spacing-1 $spacing-2;
}

.label {
  color: $content-secondary-color;
}
